import { format, parseISO } from 'date-fns';
import { T_Customer, UpgradeCustomerDetails, YesNoOptionCheckCodes } from '../../../types';
import { IUpgradableBoxesStore } from '../../../entry';
import { AddressService } from '../../../services/address';
import { getServiceAddress } from './helpers';
export const createUpgradeCustomerDetails = async (
    customer: T_Customer,
    upgradableBoxDetails: IUpgradableBoxesStore,
    hasNonPodBox: boolean,
    addressService: AddressService
): Promise<UpgradeCustomerDetails> => {
    const primaryDetails = customer.Parties.find(p => p.id === '1')?.types['MP:Primary'] || undefined;
    const makeAlternateEmpty = !upgradableBoxDetails.slots || upgradableBoxDetails.mainContactAvailability == YesNoOptionCheckCodes.YES.value;
    const dateOfBirth = primaryDetails?.personalDetails.dob
        ? format(parseISO(primaryDetails?.personalDetails.dob), 'yyyy-MM-dd')
        : null;
    const phoneNumber = primaryDetails?.contactDetails?.[0];
    const isPhoneNumberUpdateRequired =
        `${upgradableBoxDetails.areaCode}${upgradableBoxDetails.phoneNumber}` !==
        `${phoneNumber?.areaCode}${phoneNumber?.number}`;
    let customerDetails: UpgradeCustomerDetails = {
        email: customer.serviceContactEmail,
        dateOfBirth,
        firstName: primaryDetails?.personalDetails.firstName ?? '',
        lastName: primaryDetails?.personalDetails.lastName ?? '',
        phoneNumbers: [
            {
                type: 'Primary',
               phoneNumber: {
                    areaCode: ((hasNonPodBox && upgradableBoxDetails.areaCode && isPhoneNumberUpdateRequired) ? upgradableBoxDetails?.areaCode : phoneNumber?.areaCode) ?? '',
                    number: ((hasNonPodBox && upgradableBoxDetails.areaCode && isPhoneNumberUpdateRequired) ? upgradableBoxDetails?.phoneNumber : phoneNumber?.number) ?? '',
                },
                isPhoneNumberUpdateRequired: (hasNonPodBox && upgradableBoxDetails.areaCode) ? isPhoneNumberUpdateRequired : false,
            },
        ],
    };

    // Only add these fields if hasNonPodBox is true
    if (hasNonPodBox) {
        let serviceAddress;
        if (upgradableBoxDetails?.serviceAddress?.id)
            serviceAddress = await getServiceAddress(addressService, upgradableBoxDetails?.serviceAddress);

        customerDetails = {
            ...customerDetails,
            additionalDetails: {
                alternateName: `${makeAlternateEmpty ? '' : upgradableBoxDetails.alternateName}`,
                alternateEmail: '',
                alternatePhoneNumber: [
                    {
                        type: 'primary',
                        phoneNumber: {
                            areaCode: `${makeAlternateEmpty ? '' : upgradableBoxDetails.alternateAreaCode}`,
                            number: `${makeAlternateEmpty ? '' : upgradableBoxDetails.alternatePhoneNumber}`,
                        },
                    },
                ],
            },
            siteFeature: [
                {
                    name: 'Account holder availability',
                    value: `${!upgradableBoxDetails.slots ? '' : upgradableBoxDetails.mainContactAvailability}`,
                },
                {
                    name: 'Dog',
                    value: `${!upgradableBoxDetails.slots ? '' : upgradableBoxDetails.dogs}`,
                },
            ],
            errorCodes: [],
            techNotes: `${upgradableBoxDetails.techNotes}`,

        };
        if (serviceAddress) {
            customerDetails.serviceAddress = {
                tuiid: serviceAddress?.tuiid,
                street: serviceAddress?.street,
                suburb: serviceAddress?.suburb,
                city: serviceAddress?.city,
                postCode: serviceAddress?.postCode,
                isValidated: true,
            };
        }
    };

    return customerDetails;
};
